import classnames from 'classnames';
import Image from 'next/image';

import unitLeftArrow from 'public/images/unit_left_arrow.svg';
import unitRightArrow from 'public/images/unit_right_arrow.svg';
import { defaultExpertCardDimensions } from './ExpertCard';

export const ExpertsCarouselArrow = ({
  onClick,
  isVisible,
  direction,
  className,
  customHeight,
}: {
  onClick: () => void;
  isVisible: boolean;
  direction: 'prev' | 'next';
  className?: string;
  customHeight?: string;
}): React.ReactElement => {
  const isPrev = direction === 'prev';
  const position = isPrev
    ? 'absolute left-0 top-0 h-full flex items-center px-3 md:px-3.5 xl:px-4 transition-colors z-10'
    : 'absolute right-0 top-0 h-full flex items-center px-3 md:px-3.5 xl:px-4 transition-colors';

  const arrowPosition = isPrev
    ? '-left-5 sm:-left-8 md:-left-9 xl:-left-10'
    : '-right-5 sm:-right-8 md:-right-9 xl:-right-10';

  return (
    <button
      onClick={onClick}
      className={classnames(
        position,
        arrowPosition,
        { 'opacity-0 pointer-events-none': !isVisible },
        customHeight || defaultExpertCardDimensions.height,
        className
      )}
      aria-label={isPrev ? 'Previous' : 'Next'}
    >
      <Image
        src={isPrev ? unitLeftArrow : unitRightArrow}
        alt={isPrev ? 'Previous' : 'Next'}
        width={28}
        height={48}
        className="w-[13px] h-[21px] md:w-[26px] md:h-[42px]"
        priority
      />
    </button>
  );
};
